
import { Toast, Notify } from 'vant';
import * as echarts from 'echarts'
import WebSocketDispatch from "@/assets/js/webSocket/index";

let ws = new WebSocketDispatch()

export default {
    install(Vue, options) {
        Vue.prototype.$Toast = Toast
        Vue.prototype.$Notify = Notify
        Vue.prototype.$echarts = echarts
        Vue.prototype.$ws = ws

    }
}
